import React from "react";
import { useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";

const color = {
  bg: "#000000",
  neon: "#ff1026",
  purple: "#a30013",
};

const FontImport = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700;900&family=Rajdhani:wght@400;500;600;700&display=swap');
  `}</style>
);

const fadeIn = keyframes`
  0% { opacity:0; transform: translateY(30px);}
  100% { opacity:1; transform: translateY(0);}
`;

const MainBox = styled.div`
  background: ${color.bg};
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Rajdhani', sans-serif;
`;

const Card = styled.div`
  background: rgba(0,0,0,0.9);
  border-radius: 28px;
  box-shadow: 0 0 40px rgba(255,16,38,0.2);
  border: 1px solid rgba(255,16,38,0.2);
  padding: 52px 62px;
  text-align: center;
  animation: ${fadeIn} .7s;
  transition: all 0.3s;
  &:hover {
    box-shadow: 0 0 60px rgba(255,16,38,0.3);
    border-color: ${color.neon};
    transform: translateY(-5px);
  }
`;

const GoButton = styled.button`
  background: linear-gradient(135deg, ${color.neon}, ${color.purple});
  color: #fff;
  font-weight: 900;
  font-size: 1.19rem;
  padding: 18px 58px;
  border-radius: 33px;
  border: none;
  box-shadow: 0 0 20px rgba(255,16,38,0.4);
  margin-top: 34px;
  cursor: pointer;
  transition: all 0.2s;
  font-family: 'Rajdhani', sans-serif;
  &:hover {
    background: linear-gradient(135deg, ${color.purple}, ${color.neon});
    box-shadow: 0 0 30px rgba(255,16,38,0.6);
    transform: scale(1.05) translateY(-2px);
  }
`;

// ... import, styled-components ทั้งหมด (เหมือนเดิม) ...

export default function WinRateTierSelection() {
  const navigate = useNavigate();
  return (
    <MainBox>
      <FontImport />
      <Card>
        <div style={{
          fontWeight: 900,
          fontSize: "2.3rem",
          color: color.neon,
          marginBottom: 12,
          letterSpacing: 1,
        }}>
          Win/Lose Ratio & Pool Heroes
        </div>
        <div style={{
          fontWeight: 700,
          color: "#fff",
          fontSize: "1.09rem",
          marginBottom: 15,
          opacity: 0.93,
        }}>
          กราฟนี้จะแสดง Winrate รวม (Pie Chart) <br />
          และ "Pool Heroes" คือรายชื่อฮีโร่ที่ทีมเลือกใช้จริงในแมตช์ซีซั่นนี้<br />
          <span style={{ color: color.neon, fontWeight: 800 }}>คลิกปุ่มด้านล่างเพื่อดูรายชื่อ Pool Heroes พร้อมสถิติกราฟ tier และ winrate รายตัว</span>
        </div>
        <GoButton onClick={() => navigate(`/tier-data`)}>
          ไปหน้าดู Pool Heroes & สถิติ Winrate
        </GoButton>
      </Card>
    </MainBox>
  );
}